// extracted by mini-css-extract-plugin
export default {"containerList":"styles_containerList__qUoF3"};